(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf.pdf
  (:require
   [frontend.ui.page.lp-portal.report.pdf.view :as report]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.summary-and-figures :as summary-and-figures]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :as fund-overview]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :as fund-overview]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.portfolio-information :as portfolio-information]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.investor-information :as investor-information]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.toc-page :as toc]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.data-dump :as data-dump]
  ))

(defn voima-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   [(summary-and-figures/summary-and-figures-page data)]
   (fund-overview/fund-overview-pages data)
   [(portfolio-information/portfolio-information-page data)]
   (investor-information/investor-information-pages data)))

(defn voima-last-pages
  [data]
  [(data-dump/data-dump-pages data)])


(defn voima-report
  [{:keys [fund-name reporting-period reference-date] :as view-data}]
  (report/generic-report view-data (voima-pages view-data) fund-name reporting-period reference-date "" ""))
